module.exports = __webpack_public_path__ + "img/bussines--icon.cc9fb7fe.svg";